import { render } from "./WalletView.vue?vue&type=template&id=45ac4d6a&scoped=true&ts=true"
import script from "./WalletView.vue?vue&type=script&lang=ts"
export * from "./WalletView.vue?vue&type=script&lang=ts"

import "./WalletView.vue?vue&type=style&index=0&id=45ac4d6a&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ac4d6a"]])

export default __exports__